import { Link } from "react-router-dom";
import { ArrowUpRight, ArrowRight, MapPin } from "lucide-react";
import { Seo } from "@/components/Seo";
import { Reveal } from "@/components/Reveal";
import { CITIES } from "@/siteData";

const ServiceAreas = () => (
  <>
    <Seo
      title="Painting Service Areas Across the KC Metro | JC Colors"
      description="JC Colors Remodeling LLC serves Overland Park KS, Kansas City MO, Lenexa KS and Olathe KS with painting and drywall services."
    />

    <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 sm:py-24 lg:px-12" data-testid="service-areas-page">
      <Reveal>
        <p className="font-mono-accent text-xs uppercase tracking-[0.25em] text-amber-700">
          Service Areas
        </p>
        <h1 className="mt-4 max-w-3xl font-display text-4xl font-extrabold leading-[1.1] tracking-tight text-slate-900 sm:text-5xl">
          Where JC Colors works in the Kansas City metro
        </h1>
        <p className="mt-6 max-w-2xl text-base leading-relaxed text-slate-600 sm:text-lg">
          JC Colors Remodeling LLC is a service-area painting and drywall
          company based in the Kansas City metro. Most of our work is in four
          communities we know well — Overland Park, Kansas City MO, Lenexa and
          Olathe — and we're happy to talk if you're just outside them.
        </p>
      </Reveal>

      <div className="mt-12 grid gap-6 sm:grid-cols-2">
        {CITIES.map((c, i) => (
          <Reveal key={c.slug} delay={i * 0.08}>
            <Link
              to={`/service-areas/${c.slug}`}
              data-testid={`service-areas-city-card-${c.slug}`}
              className="group flex h-full flex-col justify-between rounded-3xl border border-slate-200 bg-white p-8 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:border-amber-600/50 hover:shadow-xl"
            >
              <div>
                <span className="inline-flex items-center gap-2 rounded-full bg-amber-600/10 px-3 py-1 text-xs font-semibold text-amber-700">
                  <MapPin className="h-3.5 w-3.5" />
                  {c.city}, {c.state}
                </span>
                <h2 className="mt-4 font-display text-2xl font-bold tracking-tight text-slate-900">
                  Painters & drywall in {c.city}, {c.state}
                </h2>
                <p className="mt-3 text-sm leading-relaxed text-slate-600">
                  {c.body[0].split(".")[0]}.
                </p>
              </div>
              <span className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-amber-700">
                Painting services in {c.city}
                <ArrowUpRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </span>
            </Link>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1} className="mt-14">
        <div className="flex flex-col items-start justify-between gap-6 rounded-3xl bg-slate-900 p-8 sm:flex-row sm:items-center sm:p-10">
          <div>
            <h2 className="font-display text-xl font-bold text-white sm:text-2xl">
              Just outside these cities?
            </h2>
            <p className="mt-2 max-w-xl text-sm leading-relaxed text-slate-400">
              We regularly take projects across the wider KC metro. Call
              913-244-4798 and ask — if we can't take it, we'll tell you
              straight.
            </p>
          </div>
          <Link
            to="/contact"
            data-testid="service-areas-estimate-button"
            className="inline-flex items-center gap-2 rounded-full bg-amber-600 px-7 py-3.5 text-sm font-semibold text-white shadow-md transition-all duration-200 hover:scale-105 hover:bg-amber-700"
          >
            Get a Free Estimate
            <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </Reveal>
    </section>
  </>
);

export default ServiceAreas;
